module.exports = __webpack_public_path__ + "img/article.e341c19f.webp";